import React, {useContext, useEffect, useMemo, useRef, useState} from "react";
import {Container, Form} from "react-bootstrap";
import {AgGridReact} from "ag-grid-react";
import ActionsRenderer from "components/ActionsRenderer";
import ActionPanelLayout from "layouts/ActionPanelLayout";
import useWindowDimensions from 'hooks/Dimensions.js'
import PageHeader from "components/PageHeader";
import {ActionPanelContext} from "context/action";
import {SecurityContext} from "context/security";
import {UtilsContext} from "context/utils"
import {
    ASSET_TRANSFER_LIST_URL,
    ASSET_TRANSFER_UPDATE_LIST_NAME_URL,
    ASSET_TRANSFER_DELETE_LIST_URL, ASSET_TRANSFER_SEARCH_URL
} from "service/UrlConstant";
import {ToastContext} from "context/Toast";
import {dateToString, stringToDate} from "utils/FormatUtils";
import {ASSET_TRANSFER_CAPTURE_PANEL_ACTIVITIES_PAGE} from "./context/AssetTransferContext";
import * as URL from "service/UrlConstant";
import AuthenticationService from "service/AuthenticationService";
import { columnDefsActivitiesPanel as assetTransferActColumnDefs} from "./AssetTransferActivitiesPanel"
import {
    DEFAULT_GRID_PAGINATION_SIZE,
    ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE,
    GRID_COLUMN_PROPERTY
} from "utils/Constants";
import {createExcelExportParams, getFilteredColumns, updateColumnHideState} from "../../utils/ExcelExportUtils";
import {addPropertiesToGridColumns, getDisplayedNumberOfGridRows, updateTradesRowData} from "../../utils/gridColumnUtils";
import ScrollButton from "../../components/AgGridToolbar/ToolBarButtons/ScrollButton";
import {AssetTransferContext} from "./context";

export default function AssetTransferListPanel(props) {
    const {hiddenExportGridApi,paginationPageSize, showButton, setShowButton} = useContext(UtilsContext);
    const {success, alert, error} = useContext(ToastContext);
    const {
        makeGetRequest,
        makePostRequest,
        makeDeleteRequest,
        makePatchRequestWithParams
    } = useContext(SecurityContext);
    const {assetTransferCaptureDisplayState, setAssetTransferCaptureDisplayState, buildAssetTransferActivitiesSearch, gridColumnApi,
        setGridColumnApi, columnState, setColumnState} = useContext(AssetTransferContext);
    const {setHandleDeleteFunction, setHandleRenameFunction, setSavedSearchName, setHandleExportFunction} = useContext(ActionPanelContext);

    const [rowData, setRowData] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [show, setShow] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showRename, setShowRename] = useState(false);
    const [showExport, setShowExport] = useState(false);
    const [actionForAccount, setActionForAccount] = useState('');
    const assetTransferListsGrid = useRef(null);
    const [saveAssetTransferColumnDefs, setSavedAssetTransferColumDefs] = useState(assetTransferActColumnDefs)

    const myGrid = useRef(null);
    const {isDesktop, isMobile} = useWindowDimensions();

    const assetTransferListSearchDataValueGetter = function (params) {
        let assetTransferSearchData = {
            savedName: params.data.savedName,
            managerId: params.data.managerId,
            subManagerId: params.data.subManagerId,
            status: params.data.status,
            accountId: params.data.accountId,
            startDate: params.data.startDate,
            endDate: params.data.endDate
        }
        return assetTransferSearchData;
    }

    const columnTypes = {
        actionColType: {
            sortable: false,
            resizable: false,
            floatingFilter: false,
            filter: false,
            enableCellChangeFlash: false,
            pinned: isDesktop ? '' : 'right',
            width: isDesktop ? 250 : 100,
        },
        flexColType: {
            sortable: false,
            resizable: false,
            floatingFilter: false,
            filter: false,
            enableCellChangeFlash: false,
            suppressMenu: true,
            flex: 1,
            suppressMovable: true,
        }
    }

    const defaultColDef = {
        sortable: true,
        resizable: true,
        floatingFilter: true,
        filter: true,
        enableCellChangeFlash: true,
        lockPinned: isMobile ? true : false,
    };

    const updateAssetTransferSearch = (savedName, gridApi, onSuccess, onError) => {
        const selectedRow = gridApi.getSelectedRows()[0];
        const assetTransferListId = selectedRow.assetTransferListId;

        const onSuccessResponse = (response) => {
            if (onSuccess) onSuccess();
            selectedRow.savedName = savedName;
            gridApi.applyTransaction({update: [selectedRow]});
            success('Asset Transfer activities search successfully saved');
        }

        const onErrorResponse = (err) => {
            console.error(err);
            if(onError) onError(err);
        }

        makePatchRequestWithParams(
            ASSET_TRANSFER_UPDATE_LIST_NAME_URL + "/" + assetTransferListId, {savedName: savedName}, onSuccessResponse, onErrorResponse);
    };

    const deleteTradeSearch = (gridApi, onSuccess, onError) => {

        const selectedRow = gridApi.getSelectedRows()[0];
        const assetTransferListId = selectedRow.assetTransferListId;

        const onSuccessResponse = (response) => {
            if (onSuccess) onSuccess();
            gridApi.applyTransaction({remove: [selectedRow]});
            success('Asset Transfer activities search successfully deleted');
        }

        const onErrorResponse = (err) => {
            console.error(err);
            if (onError) onError(err);
            error('Error occurred with deleting assetTransfer list');
        }

        makeDeleteRequest(
            ASSET_TRANSFER_DELETE_LIST_URL + "/" + assetTransferListId, onSuccessResponse, onErrorResponse);
    };


    const messageToErrors = (message) => {
        // message
    }
    const loadSavedTradesList = () => {
        const onSuccess = (response) => {
            if(!response.data || response.data.length === 0){
                console.log("No saved assetTransfer activities searches found")
            }
            else {
                setRowData([...response.data]);
            }
        }
        const onError = (err) => {
            console.error(err);
            error('Error loading saved assetTransfer list');
        }

        makeGetRequest(ASSET_TRANSFER_LIST_URL, {
            cdUser: AuthenticationService.getAuthenticatedUserName(),
        }, onSuccess, onError);
    };

    const loadAssetTransferActivitiesForSavedList = (savedAssetTransferListData) => {
        const searchCriteria = {
            savedName: savedAssetTransferListData.savedName,
            managerId: savedAssetTransferListData.managerId,
            managerNameShort: savedAssetTransferListData.managerNameShort,
            subManagerId: savedAssetTransferListData.subManagerId,
            subManagerNameShort: savedAssetTransferListData.subManagerNameShort,
            accountId: savedAssetTransferListData.accountId,
            accountNameShort: savedAssetTransferListData.accountNameShort,
            status: savedAssetTransferListData.status,
            startDate: (savedAssetTransferListData.startDate ? savedAssetTransferListData.startDate.toString() : ""),
            endDate: (savedAssetTransferListData.endDate ? savedAssetTransferListData.endDate.toString() : ""),
            gridState: savedAssetTransferListData.gridState ?JSON.parse(savedAssetTransferListData.gridState) : null
        }

        const onSuccessResponse = (response) => {

            if (!response.data || response.data.length === 0) {
                alert('No Asset Transfer activities found matching your saved assetTransfers list');
            } else {
                let assetTransferCaptureDisplayActivities = JSON.parse(JSON.stringify(assetTransferCaptureDisplayState));
                assetTransferCaptureDisplayActivities.assetTransferActivitiesSearch = buildAssetTransferActivitiesSearch(
                    searchCriteria.managerId,
                    searchCriteria.managerNameShort,
                    searchCriteria.subManagerId,
                    searchCriteria.subManagerNameShort,
                    searchCriteria.accountId,
                    savedAssetTransferListData.accountCode,
                    searchCriteria.accountNameShort,
                    searchCriteria.status,
                    searchCriteria.startDate,
                    searchCriteria.endDate,
                    response.data
                );

                assetTransferCaptureDisplayActivities.isSavedTradeList = true;
                assetTransferCaptureDisplayActivities.savedName = searchCriteria.savedName;
                assetTransferCaptureDisplayActivities.savedNameListId = savedAssetTransferListData.assetTransferListId;
                assetTransferCaptureDisplayActivities.currentPage = ASSET_TRANSFER_CAPTURE_PANEL_ACTIVITIES_PAGE;
                if(searchCriteria.gridState) {
                    setColumnState(JSON.parse(savedAssetTransferListData.gridState))
                } else {
                    setColumnState(null)
                }
                setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayActivities);
            }
        }

        const onErrorResponse = (err) => {
            console.error("Error", err);
            error("Error occurred with load assetTransfer activities for saved assetTransfers list");
        }

        makePostRequest(searchCriteria,
            URL.ASSET_TRANSFER_SEARCH_URL, onSuccessResponse, onErrorResponse);
    };

    const exportAssetTransferList = (type, rowData, gridApi, onSuccess, onError) => {
        const selectedRow = gridApi.getSelectedRows()[0];
        const searchParam = {
            savedName: selectedRow.savedName,
            managerId: selectedRow.managerId,
            managerNameShort: selectedRow.managerNameShort,
            subManagerId: selectedRow.subManagerId,
            subManagerNameShort: selectedRow.subManagerNameShort,
            accountId: selectedRow.accountId,
            accountNameShort: selectedRow.accountNameShort,
            status: selectedRow.status,
            startDate: selectedRow.startDate,
            endDate: selectedRow.endDate
        }

        const onSuccessResponse = (response) => {
            const columnState = JSON.parse(selectedRow.gridState)
            let updatedTradesColumnsDef = updateColumnHideState(assetTransferActColumnDefs, columnState)

            updatedTradesColumnsDef = updatedTradesColumnsDef.filter(cols => cols.field !== 'checkbox' && cols.field !== 'View');
            hiddenExportGridApi.current.api.setColumnDefs(updatedTradesColumnsDef);
            //Set Data
            const rowData = updateTradesRowData(response.data)
            hiddenExportGridApi.current.api.setRowData(rowData)
            let filteredColumnNames = getFilteredColumns(assetTransferListsGrid);
            //Export as csv/excel
            type==='EXCEL' ?
                hiddenExportGridApi.current.api.exportDataAsExcel(createExcelExportParams(filteredColumnNames)) :
                hiddenExportGridApi.current.api.exportDataAsCsv(filteredColumnNames)
        }

        const onErrorResponse = (err) => {
            const msg = "Error occurred when exporting the AssetTransfer List";
            console.error(msg + ": ", err);
            if(onError) onError(err);
            error(msg);
        }

        makePostRequest(searchParam, URL.ASSET_TRANSFER_SEARCH_URL  , onSuccessResponse, onErrorResponse);
    };

    useEffect(() => {
        loadSavedTradesList();
    }, [])

    const handleActionIconClick = (field) => {
        setActionForAccount(field.savedName);
        setSavedSearchName(field.savedName);
        setShow(true);
    }

    const handleExportActionClicked = (field) => {
        setActionForAccount(field.savedName);
        setShow(true);
        setShowExport(true);
    }

    const handleRenameActionClicked = (searchData) => {
        setSavedSearchName(searchData.savedName);
        setShow(true);
        setShowRename(true);
    }

    const handleDeleteActionClicked = (field) => {
        setActionForAccount(field.savedName);
        setShow(true);
        setShowDelete(true);
    }

    function managerGetter(params) {
        return params.data.managerNameShort;
    }

    function accountGetter(params) {
        const accountCode = params.data.accountCode
        const accountNameShort = params.data.accountNameShort
        return accountCode && accountNameShort ? accountCode + ' - ' + accountNameShort : 'ALL';
    }

    const columnDefs = [
        {headerName: 'assetTransferListId', field: 'assetTransferListId',hide: true, suppressColumnsToolPanel: true},
        {headerName: 'accountCode', field: 'accountCode',hide: true, suppressColumnsToolPanel: true},
        {headerName: 'accountId', field: 'accountId',hide: true, suppressColumnsToolPanel: true},
        {headerName: 'managerId', field: 'managerId',hide: true, suppressColumnsToolPanel: true},
        {headerName: 'Name', field: 'savedName', cellRenderer: "assetTransferNameRenderer"},
        {headerName: 'Status', field: 'status'},
        {headerName: 'Entity', valueGetter: managerGetter},
        {headerName: 'Account', valueGetter: accountGetter},
        {headerName: 'Start Date', field: 'startDate', valueGetter: (params)=>stringToDate(dateToString(params.data.startDate))},
        {headerName: 'End Date', field: 'endDate', valueGetter: (params)=>stringToDate(dateToString(params.data.endDate))},
        {
            headerName: 'Actions',
            field: 'account',
            cellRenderer: "actionsRenderer",
            type: 'actionColType',
            valueGetter: assetTransferListSearchDataValueGetter,
            cellRendererParams: {
                clicked: (searchData) => handleActionIconClick(searchData),
                onAction1Clicked: (searchData) => handleExportActionClicked(searchData),
                onAction2Clicked: (searchData) => handleRenameActionClicked(searchData),
                onAction3Clicked: (searchData) => handleDeleteActionClicked(searchData)
            }
        },
        ,{headerName: '', field: '', type: 'flexColType', suppressColumnsToolPanel: true}
    ];

    const updatedColumnDefs = useMemo(() => addPropertiesToGridColumns(columnDefs, GRID_COLUMN_PROPERTY), []);

    const cellClicked = (params) => {
        params.node.setSelected(true)
        params.api.ensureIndexVisible(params.node.rowIndex, 'top')
    }

    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
        setHandleRenameFunction({handleRename: updateAssetTransferSearch, gridApi: params.api});
        setHandleDeleteFunction({handleDelete: deleteTradeSearch, gridApi: params.api});
        setHandleExportFunction({handleExport:exportAssetTransferList, gridApi: params.api});
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }

    const searchNameRenderer = function (props) {
        return (<>
            <a className="td-link" href="#" onClick={() => {
                loadAssetTransferActivitiesForSavedList(props.data);
            }}>{props.value}</a>
        </>);
    }
    const onDataRendered = (params) => {
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }

    const onPaginationChange = (params) => {
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }
    return (<>
        <Container fluid>
            <PageHeader text="Asset Transfer Activities">
                <h3>Saved Searches</h3>
            </PageHeader>

            <div
                ref={myGrid}
                id="myGrid"
                className="ag-theme-alpine ag-grid-block">
                <AgGridReact
                    ref={assetTransferListsGrid}
                    frameworkComponents={{
                        assetTransferNameRenderer: searchNameRenderer,
                        actionsRenderer: ActionsRenderer,
                    }}
                    paginationPageSize={DEFAULT_GRID_PAGINATION_SIZE}
                    groupDefaultExpanded={'1'}
                    enableRowGroup={false}
                    suppressDragLeaveHidesColumns={true}
                    suppressMakeColumnVisibleAfterUnGroup={true}
                    suppressModelUpdateAfterUpdateTransaction={true}
                    suppressScrollOnNewData={true}
                    suppressAggFuncInHeader={true}
                    allowShowChangeAfterFilter={false}
                    rowGroupPanelShow={'never'}
                    enableSorting={true}
                    enableFilter={false}
                    pagination={true}
                    onGridReady={onGridReady}
                    defaultColDef={defaultColDef}
                    onFirstDataRendered={onDataRendered}
                    columnDefs={updatedColumnDefs}
                    columnTypes={columnTypes}
                    rowData={rowData}
                    animateRows={true}
                    onCellClicked={cellClicked}
                    onPaginationChanged={onPaginationChange}
                >
                </AgGridReact>
            </div>

        </Container>
        {showButton && <ScrollButton showButton={showButton}/>}
        <ActionPanelLayout actionForAccount={actionForAccount} show={show} setShow={setShow}
                           showExport={showExport} setShowExport={setShowExport}
                           showRename={showRename} setShowRename={setShowRename}
                           showDelete={showDelete} setShowDelete={setShowDelete} gridApi={gridApi}
        />

    </>);
}
